// 3rd party imports
import * as React from 'react';

// bernie
import { LocalizedComponentProps, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// ui
import { UitkHeading, UitkSubheading } from 'uitk-react-text';
import { UitkPrimaryButton } from 'uitk-react-button';
import { UitkSpacing } from 'uitk-react-spacing';

// components
import { BookmarkletLink } from './bookmarklet-link';
import { UitkList, UitkListItem } from 'uitk-react-list';

@withLocalization
export class Bookmarklet extends React.Component<LocalizedComponentProps> {
  public render() {
    const { l10n } = this.props;

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <main>
          <UitkHeading tag="h1" size={3}>
            <LocalizedText message="bookmarklet.header" />
          </UitkHeading>
          <UitkSubheading>
            <LocalizedText message="bookmarklet.subheader" />
          </UitkSubheading>
          <UitkSpacing className="uitk-type-list-400" padding={{ block: 'three', inline: 'four' }}>
            <UitkList type="ordered">
                <UitkListItem key="listitem-1-1">
                  <LocalizedText message="bookmarklet.step1" />
                </UitkListItem>
                <UitkListItem key="listitem-1-2">
                  <LocalizedText message="bookmarklet.step2" />
                </UitkListItem>
                <UitkListItem key="listitem-1-3">
                  <LocalizedText message="bookmarklet.step3" />
                  <UitkSpacing padding={{ block: 'three' }}>
                    <div>
                      <BookmarkletLink>
                        <UitkPrimaryButton>
                          {l10n.formatText('bookmarklet.button.label')}
                        </UitkPrimaryButton>
                      </BookmarkletLink>
                    </div>
                  </UitkSpacing>
                </UitkListItem>
                <UitkListItem>
                  <LocalizedText message="bookmarklet.step4" />
                </UitkListItem>
                <UitkListItem>
                  <LocalizedText message="bookmarklet.step5" />
                </UitkListItem>
            </UitkList>
          </UitkSpacing>
        </main>
      </UitkSpacing>
    );
  }
}
